// extracted by css-extract-rspack-plugin
export default {"menu":"lJTWAPxWZkmf8yKl"};